App.DashboardController = Em.Controller.extend
  session: Em.inject.service()
  env: Em.inject.service('environment')
  inappSupport: Em.inject.service()

  needs: ['clients']

  ###
  # Query-параметры
  ###
  queryParams: [ 'range', 'restaurant_ids']

  # диапазон динамики заказов
  range: 'year'

  # выбранные рестораны
  restaurants: []
  restaurant_ids: ''
  restaurantIdsInit: (->
    return unless typeof @get('restaurant_ids') == 'string' and !@get('restaurantsParsed')
    @set('restaurantsParsed', true)
    @set('restaurants', @get('restaurant_ids').split(',').map (id) =>
      @store.find('restaurant', id))
  ).observes('restaurant_ids')

  # доступные рестораны
  restaurantsAvailable: []

  dateFormat: (->
    switch @get('range')
      when 'year' then 'MMMM YYYY'
      else 'D MMMM YYYY'
  ).property('range')

  # Интересный момент:
  # Observer срабатывает, когда Ember выставляет значение из
  # query-params
  transitionComplete: false

  ###
  # Подгружаем новую порцию при изменении параметра
  ###
  isDynamicsLoading: false

  dynamicsStatData: null
  basketsStatData:  null
  checklistData:    null

  hasZeroData: false

  translatedChecklist: (->
    @get('checklistData').map (entry) =>
      label:   @get('env').translate("checklist.#{entry.type}")
      type:    entry.type
      checked: entry.checked
    .filter (entry) => not Em.isEmpty(entry.label)
  ).property('checklistData.[]')


  isSetupDone: (->
    @get('translatedChecklist').isEvery('checked', true)
  ).property('translatedChecklist.@each.checked')


  checkedItemsCount: (->
    @get('translatedChecklist')
      .filter((d) -> d.checked)
      .length
  ).property('translatedChecklist.@each.checked')

  onRangeChanged: (->
    return unless @get('transitionComplete')
    restaurant_ids = @get('restaurants').map (r) => r.get('id')
    @set('restaurant_ids', restaurant_ids)
    @send('fetchDynamics', @get('range'), restaurant_ids)
    @loadBasketStats()
  ).observes('range', 'restaurants.@each.id')


  isLoadingBasketStat: false
  forceLoadBasketState: true

  loadBasketStats: ->
    @set('isLoadingBasketStat', true)

    organization = @get('session.currentOrganization')
    range        = @get('range')
    restaurant_ids = @get('restaurant_ids')

    organization.statsBaskets({ max_dishes: 10, max_coords: 2000, restaurants: restaurant_ids, range })
    .then (data) =>
      @set('basketsStatData', data)
    .finally =>
      @set('isLoadingBasketStat', false)

  ordersDynamicsBinding:    'dynamicsStatData.orders_dynamics'
  popularDishesBinding:     'basketsStatData.popular_dishes'
  ordersCoordinatesBinding:  'basketsStatData.order_coordinates'

  currentPeakLoadRange: 'whole_week'

  peakLoadData: (->
    switch @get('currentPeakLoadRange')
      when 'weekends'   then @get('dynamicsStatData.peak_load.weekends')
      when 'whole_week' then @get('dynamicsStatData.peak_load.whole_week')
      when 'work_days'  then @get('dynamicsStatData.peak_load.work_days')
  ).property('currentPeakLoadRange', 'dynamicsStatData')

  visibleAudienceDashboard : false

  clientsGroupsData: [],

  watchclientsStatData: (->
    clientsStatData = @get 'clientsStatData'

    if Ember.isEmpty(clientsStatData) then return

    @set 'clientsGroupsData', _.map clientsStatData.recurrence_distribution, (value, key) ->
      {
        type: key
        count: value
      }
  ).observes('clientsStatData.@each')

  mailTo: (->
    organization = @get('session.currentOrganization')
    "mailto:ip@smatomato.ru?subject=Support[#{organization.get('name')}]"
  ).property('session.currentOrganization')

  # Группа параметров для графика динамики
  hoveredIndex: undefined
  summaryData: ( ->
    i = @get('hoveredIndex')
    if i? then @get('ordersDynamics.values')[i] else @get('ordersDynamics.summary')
  ).property('hoveredIndex', 'ordersDynamics.summary')

  actions:
    # theme_selected:      'Выберите дизайн сайта'
    # menu_filled:         'Добавьте несколько блюд'
    # has_delivery_zones:  'Задайте зону и условия доставки'
    # has_couriers:        'Подключите курьеров'
    # has_address_phone:   'Укажите телефон и адрес ресторана'
    # has_domain:          'Выберите домен'
    # is_published:        'Опубликуйте сайт'
    checklistResolver: (type) ->
      switch type
        when 'theme_selected'
          @transitionToRoute('themes')
        when 'menu_filled'
          @transitionToRoute('categories')
        when 'has_delivery_zones'
          @transitionToRoute('delivery')
        when 'has_couriers'
          @transitionToRoute('delivery.couriers')
        when 'has_address_phone'
          @transitionToRoute('restaurants')
        when 'has_domain'
          @transitionToRoute('settings.organization')
        when 'is_published'
          @transitionToRoute('themes')
      false

    askQuestion: ->
      @get('inappSupport').initiateDialogue()
      false

    transitionToClients: (type) ->
      clients = @get 'controllers.clients'

      clients.get('selectedRecurrence').forEach (item) ->
        item.set('checked', item.get('type') == type)

      @transitionToRoute 'clients'

